import React, { useState, useContext, useMemo } from "react";
import SearchInput from "../searchInput/SearchInput";
import RRDistribuciones from "../renderRows/RRDistribuciones";
import windowSizeContext from "../../context/windowSize/windowSizeContext";
import normalizeText from "../../utils/normalizeText";
import './DistribucionList.css';

function DistribucionList({ distribucionesConSubcuentas = [] }) {

    const [filter, setFilter] = useState("");

    const wSizeContext = useContext(windowSizeContext);
    const { height } = wSizeContext;

    const filteredItems = useMemo(() => {
        if (!filter) return distribucionesConSubcuentas;
        const f = normalizeText(filter);
        return distribucionesConSubcuentas.filter(d =>
            normalizeText((d.codDis || "").replace(/\s+/g, "")).includes(f) ||
            normalizeText(d.codDisDescrp || "").includes(f) ||
            normalizeText((d.codDim || "").replace(/\s+/g, "")).includes(f) ||
            normalizeText(d.codDimDescrp || "").includes(f)
        );
    }, [distribucionesConSubcuentas, filter]);

    return (
        <div>
            <div style={{ marginLeft: "-150px" }}>
                <SearchInput defaultValue={filter} buscar={setFilter} />
            </div>
            <div className='distribucionesListDiv' style={{ height: height - 200, overflowY: 'scroll' }}>
                {filteredItems.length === 0 ? (
                    <p className="no-records-message">No hay registros para mostrar</p>
                ) : (
                    filteredItems.map((item, index) => (
                        <RRDistribuciones
                            key={`${item.codDim}-${item.codDis}`}
                            item={item}
                            style={{}}
                        />
                    ))
                )}
            </div>
        </div>
    );
}

export default DistribucionList;
